/**
 * Organisation.labels is a free-text, comma-separated string. Integrations add searchable
 * identifiers (e.g. FlexiBee instanceId and licenseId) to it as bare values next to user labels.
 */

// organisations.labels is stored as a varchar(255) column.
export const ORGANISATION_LABELS_MAX_LENGTH = 255;

export function parseOrganisationLabels(labels: string | null | undefined): string[] {
	return (labels || '')
		.split(',')
		.map((token) => token.trim())
		.filter((token) => token.length > 0);
}

// Appends bare values that are not already present; blank values are skipped.
// If the result would not fit the column, the oldest existing labels are dropped first, then the last new values.
export function addOrganisationLabels(
	labels: string | null | undefined,
	values: Array<string | null | undefined>,
	maxLength: number = ORGANISATION_LABELS_MAX_LENGTH,
): string {
	const kept = parseOrganisationLabels(labels);
	const added: string[] = [];
	for (const raw of values) {
		const value = String(raw ?? '').replace(/[,\s]+/g, '');
		if (value && kept.indexOf(value) < 0 && added.indexOf(value) < 0) {
			added.push(value);
		}
	}

	if (added.length === 0) {
		return kept.join(',');
	}

	while (added.length > 1 && added.join(',').length > maxLength) {
		added.pop();
	}
	while (kept.length > 0 && kept.concat(added).join(',').length > maxLength) {
		kept.shift();
	}

	return kept.concat(added).join(',');
}
